<template>
  <FlexLayout role="region">
    <BlockContainer id="meal-plan-shop-selection" :title="$t('mealPlanParameters.subTitle.shopSelection')">
      <Shops @shop-selected="onShopSelected" />
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Shops from "@/components/page-components/Shop/Shops.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";

export default {
  components: {
    FlexLayout,
    BlockContainer,
    Shops,
  },
  methods: {
    onShopSelected() {
      this.$navigateToMealPlanner();
    },
  },
}
</script>
